import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Footer from './components/Footer/Footer';
import AboutUs from './components/About/AboutUs';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Projects from './components/Projects/projects';
import Donate from './components/Donate/Donate';
import Gallery from './components/Gallery/Gallery';

 
function App() {
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<><Header /><Home /><Footer /></>} />
            <Route path="/home" element={<><Header /><Home /><Footer /></>} />
            <Route path="/projects" element={<><Header /><Projects /><Footer /></>} />
            <Route path="/gallery" element={<><Header /><Gallery /><Footer /></>} />
            <Route path="/donate" element={<><Header /><Donate /><Footer /></>} />
            <Route path="/about" element={<><Header /><AboutUs /><Footer /></>} />
          </Routes>
        </Router>
  </div>
  );
}

export default App;
